export const SUNAT_CATALOGOS = {
  TIPO_COMPROBANTE: {
    FACTURA: { codigo: "01", descripcion: "Factura", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    BOLETA: { codigo: "03", descripcion: "Boleta de venta", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    NOTA_CREDITO: { codigo: "07", descripcion: "Nota de crédito", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    NOTA_DEBITO: { codigo: "08", descripcion: "Nota de débito", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    RECIBO: { codigo: "14", descripcion: "Recibo por servicios públicos", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    RECIBO_SERVICIOS_PUBLICOS: { codigo: "14", descripcion: "Recibo por servicios públicos", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    RECIBO_HONORARIOS: { codigo: "20", descripcion: "Recibo por honorarios", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
  },
  TIPO_DOCUMENTO: {
    DNI: { codigo: "1", descripcion: "DNI", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    RUC: { codigo: "6", descripcion: "RUC", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    CE: { codigo: "4", descripcion: "Carné de extranjería", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    PAS: { codigo: "7", descripcion: "Pasaporte", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    OTRO: { codigo: "0", descripcion: "Otro", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
  },
  TIPO_OPERACION: {
    GRAVADO: { codigo: "01", descripcion: "Gravado", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    EXONERADO: { codigo: "02", descripcion: "Exonerado", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    INAFECTO: { codigo: "03", descripcion: "Inafecto", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
    EXPORTACION: { codigo: "04", descripcion: "Exportación", fuente: "SUNAT", version: "vigente", fechaActualizacion: "2026-08-14" },
  },
  MONEDA: {
    PEN: { codigo: "PEN", descripcion: "Soles", fuente: "ISO 4217", version: "vigente", fechaActualizacion: "2026-08-14" },
    USD: { codigo: "USD", descripcion: "Dólares", fuente: "ISO 4217", version: "vigente", fechaActualizacion: "2026-08-14" },
  },
};

export const normalizeCatalogCode = (catalog, value) => {
  const normalized = String(value || "").trim().toUpperCase();
  const entry = Object.entries(catalog).find(([, item]) => item.codigo === normalized || item.descripcion.toUpperCase() === normalized || String(item.codigo) === normalized);
  return entry ? entry[1] : null;
};
